import {
  businessCentralServiceBaseURL,
  financeServiceBaseURL,
  fortnoxServiceBaseURL,
  netVisorServiceBaseURL,
  powerOfficeServiceBaseURL,
} from '@/services/agent'
import ModuleEnum from '../../common/ModuleEnum'

export default class EndpointResolver {
  constructor() {}

  getMasterLogDetailsEndpoint(moduleName: string): string {
    let endpoint = ''

    if (moduleName == ModuleEnum.Fortnox.id) {
      endpoint = `${fortnoxServiceBaseURL}v1/SyncLogDetails/GetSyncLogDetails`
    } else if (moduleName == ModuleEnum.PowerOffice.id) {
      endpoint = `${powerOfficeServiceBaseURL}v1/SyncLogDetails/GetSyncLogDetails`
    } else if (moduleName == ModuleEnum.BusinessCentral.id) {
      endpoint = `${businessCentralServiceBaseURL}v1/SyncLogDetails/GetSyncLogDetails`
    }else if (moduleName == ModuleEnum.NetVisor.id) {
      endpoint = `${netVisorServiceBaseURL}v1/SyncLogJobDetails/GetSyncLogDetails`
    }else if (moduleName == ModuleEnum.Finance.id) {
      endpoint = `${financeServiceBaseURL}v1/SyncLogDetails/GetSyncLogDetails`
    }

    return endpoint
  }

  getMasterLogEndpoint(moduleName: string): string {
    let endpoint = ''

    if (moduleName == ModuleEnum.Fortnox.id) {
      // Fortnox
      endpoint = `${fortnoxServiceBaseURL}v1/SyncLogMaster/GetSyncLogMaster`
    } else if (moduleName == ModuleEnum.PowerOffice.id) {
      endpoint = `${powerOfficeServiceBaseURL}v1/SyncLogMaster/GetSyncLogMaster`
    } else if (moduleName == ModuleEnum.BusinessCentral.id) {
      endpoint = `${businessCentralServiceBaseURL}v1/SyncLogMaster/GetSyncLogMaster`
    }else if (moduleName == ModuleEnum.NetVisor.id) {
      endpoint = `${netVisorServiceBaseURL}v1/SyncLogJobMaster/GetSyncJobMasterLogs`
    }else if (moduleName == ModuleEnum.Finance.id) {
      endpoint = `${financeServiceBaseURL}v1/SyncLogMaster/GetSyncJobMaster`
    }

    return endpoint
  }

  getJobRunStatusEndpoint(moduleName: string): string {
    let endpoint = ''

    if (moduleName == ModuleEnum.Fortnox.id) {
      // Fortnox
      endpoint = `${fortnoxServiceBaseURL}v1/SyncLogMaster/GetJobRunStatus`
    } else if (moduleName == ModuleEnum.PowerOffice.id) {
      endpoint = `${powerOfficeServiceBaseURL}v1/SyncLogMaster/GetJobRunStatus`
    } else if (moduleName == ModuleEnum.BusinessCentral.id) {
      endpoint = `${businessCentralServiceBaseURL}v1/SyncLogMaster/GetJobRunStatus`
    } else if (moduleName == ModuleEnum.NetVisor.id) {
      endpoint = `${netVisorServiceBaseURL}v1/SyncLogJobMaster/GetSyncLogMasterStatus`
    }

    return endpoint
  }

  getSyncErrorsEndPoint(moduleName: string): string {
    let endpoint = ''

    if (moduleName == ModuleEnum.Fortnox.id) {
      // Fortnox
      endpoint = `${fortnoxServiceBaseURL}v1/SyncLogMaster/GetErrorListInLastSync`
    } else if (moduleName == ModuleEnum.PowerOffice.id) {
      endpoint = `${powerOfficeServiceBaseURL}v1/SyncLogMaster/GetErrorListInLastSync`
    } else if (moduleName == ModuleEnum.BusinessCentral.id) {
      endpoint = `${businessCentralServiceBaseURL}v1/SyncLogMaster/GetErrorListInLastSync`
    }

    return endpoint
  }
}
